// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Default dark theme */
  --bg-primary: #000000;
  --bg-secondary: #1B1B1B;
  --bg-tertiary: #2A2A2A;
  --text-primary: #FFFFFF;
  --text-secondary: rgba(255, 255, 255, 0.7);
  --text-tertiary: rgba(255, 255, 255, 0.5);
  --border-color: rgba(255, 255, 255, 0.1);
  --border-color-hover: rgba(255, 255, 255, 0.3);
  --accent-color: #FFFFFF;
  --success-color: #00FF00;
  --error-color: #FF0000;
  --warning-color: #FFA500;
}

body {
  margin: 0;
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

* {
  box-sizing: border-box;
  /* Force sharp corners globally - NO ROUNDED ELEMENTS */
  border-radius: 0 !important;
}

/* Override any button radius */
button, input, textarea, select {
  border-radius: 0 !important;
}

html {
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-width: 100vw;
}

body {
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-width: 100vw;
}

/* Mobile viewport protection */
@media (max-width: 375px) {
  html, body {
    max-width: 375px;
    overflow-x: hidden !important;
  }

  *, *::before, *::after {
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Prevent any element from extending beyond viewport */
  div, section, article, aside, nav, header, footer, main {
    max-width: 100% !important;
    overflow-x: hidden !important;
  }
}

/* Beautiful custom scrollbar for the entire page */
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 12px;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg,
    #FFFFFF 0%,
    #F0F0F0 25%,
    #FFFFFF 50%,
    #F0F0F0 75%,
    #FFFFFF 100%);
  border-radius: 0;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow:
    0 0 10px rgba(255, 255, 255, 0.6),
    0 0 20px rgba(255, 255, 255, 0.3),
    inset 0 1px 2px rgba(255, 255, 255, 0.8),
    inset 0 -1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

html::-webkit-scrollbar-thumb:hover,
body::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg,
    #FFFFFF 0%,
    #FAFAFA 25%,
    #FFFFFF 50%,
    #FAFAFA 75%,
    #FFFFFF 100%);
  box-shadow:
    0 0 15px rgba(255, 255, 255, 0.8),
    0 0 25px rgba(255, 255, 255, 0.4),
    inset 0 1px 3px rgba(255, 255, 255, 1),
    inset 0 -1px 3px rgba(0, 0, 0, 0.1);
  transform: scaleX(1.2);
}

html::-webkit-scrollbar-thumb:active,
body::-webkit-scrollbar-thumb:active {
  background: #FFFFFF;
  box-shadow:
    0 0 20px rgba(255, 255, 255, 1),
    0 0 30px rgba(255, 255, 255, 0.6),
    inset 0 2px 4px rgba(255, 255, 255, 1),
    inset 0 -2px 4px rgba(0, 0, 0, 0.15);
}

#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Override any global scrollbar styles */
* {
  scrollbar-width: thin !important;
  scrollbar-color: rgba(255, 255, 255, 0.8) rgba(255, 255, 255, 0.05) !important;
}

/* Ensure our white scrollbar takes precedence */
html,
body,
html *,
body * {
  scrollbar-width: thin !important;
  scrollbar-color: rgba(255, 255, 255, 0.8) rgba(255, 255, 255, 0.05) !important;
}
/* Tour active - Fix modal spotlight positioning */
body.tour-active {
  /* Prevent any transforms that could mess with joyride positioning */
  transform: none !important;
}

/* Fix modal positioning during tours */
body.tour-active [id="tour-memo-modal"] {
  /* Reset scroll position to top when tour is active */
  scroll-behavior: auto !important;
}

/* Prevent modal transforms during tour */
body.tour-active div[role="dialog"],
body.tour-active div[id^="tour-"] {
  transform: none !important;
  will-change: auto !important;
}

/* Ensure modal content is visible and positioned correctly */
body.tour-active div[id="tour-memo-modal"] * {
  transform: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,yCAAyC;EACzC,wCAAwC;EACxC,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,6BAA6B;EAC7B,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE;aACW;AACb;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,uDAAuD;EACvD;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;AACF;;AAEA,mDAAmD;AACnD;;EAEE,WAAW;AACb;;AAEA;;EAEE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;EAEE;;;;;iBAKe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C;;;;uCAIqC;EACrC,yBAAyB;AAC3B;;AAEA;;EAEE;;;;;iBAKe;EACf;;;;uCAIqC;EACrC,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB;;;;wCAIsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,gCAAgC;EAChC,8EAA8E;AAChF;;AAEA,gDAAgD;AAChD;;;;EAIE,gCAAgC;EAChC,8EAA8E;AAChF;AACA,kDAAkD;AAClD;EACE,oEAAoE;EACpE,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA,yCAAyC;AACzC;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,6DAA6D;AAC7D;EACE,0BAA0B;AAC5B","sourcesContent":[":root {\n  /* Default dark theme */\n  --bg-primary: #000000;\n  --bg-secondary: #1B1B1B;\n  --bg-tertiary: #2A2A2A;\n  --text-primary: #FFFFFF;\n  --text-secondary: rgba(255, 255, 255, 0.7);\n  --text-tertiary: rgba(255, 255, 255, 0.5);\n  --border-color: rgba(255, 255, 255, 0.1);\n  --border-color-hover: rgba(255, 255, 255, 0.3);\n  --accent-color: #FFFFFF;\n  --success-color: #00FF00;\n  --error-color: #FF0000;\n  --warning-color: #FFA500;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n* {\n  box-sizing: border-box;\n  /* Force sharp corners globally - NO ROUNDED ELEMENTS */\n  border-radius: 0 !important;\n}\n\n/* Override any button radius */\nbutton, input, textarea, select {\n  border-radius: 0 !important;\n}\n\nhtml {\n  min-height: 100vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 100%;\n  max-width: 100vw;\n}\n\nbody {\n  min-height: 100vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 100%;\n  max-width: 100vw;\n}\n\n/* Mobile viewport protection */\n@media (max-width: 375px) {\n  html, body {\n    max-width: 375px;\n    overflow-x: hidden !important;\n  }\n\n  *, *::before, *::after {\n    max-width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Prevent any element from extending beyond viewport */\n  div, section, article, aside, nav, header, footer, main {\n    max-width: 100% !important;\n    overflow-x: hidden !important;\n  }\n}\n\n/* Beautiful custom scrollbar for the entire page */\nhtml::-webkit-scrollbar,\nbody::-webkit-scrollbar {\n  width: 12px;\n}\n\nhtml::-webkit-scrollbar-track,\nbody::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 0;\n}\n\nhtml::-webkit-scrollbar-thumb,\nbody::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg,\n    #FFFFFF 0%,\n    #F0F0F0 25%,\n    #FFFFFF 50%,\n    #F0F0F0 75%,\n    #FFFFFF 100%);\n  border-radius: 0;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-shadow:\n    0 0 10px rgba(255, 255, 255, 0.6),\n    0 0 20px rgba(255, 255, 255, 0.3),\n    inset 0 1px 2px rgba(255, 255, 255, 0.8),\n    inset 0 -1px 2px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\nhtml::-webkit-scrollbar-thumb:hover,\nbody::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg,\n    #FFFFFF 0%,\n    #FAFAFA 25%,\n    #FFFFFF 50%,\n    #FAFAFA 75%,\n    #FFFFFF 100%);\n  box-shadow:\n    0 0 15px rgba(255, 255, 255, 0.8),\n    0 0 25px rgba(255, 255, 255, 0.4),\n    inset 0 1px 3px rgba(255, 255, 255, 1),\n    inset 0 -1px 3px rgba(0, 0, 0, 0.1);\n  transform: scaleX(1.2);\n}\n\nhtml::-webkit-scrollbar-thumb:active,\nbody::-webkit-scrollbar-thumb:active {\n  background: #FFFFFF;\n  box-shadow:\n    0 0 20px rgba(255, 255, 255, 1),\n    0 0 30px rgba(255, 255, 255, 0.6),\n    inset 0 2px 4px rgba(255, 255, 255, 1),\n    inset 0 -2px 4px rgba(0, 0, 0, 0.15);\n}\n\n#root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Override any global scrollbar styles */\n* {\n  scrollbar-width: thin !important;\n  scrollbar-color: rgba(255, 255, 255, 0.8) rgba(255, 255, 255, 0.05) !important;\n}\n\n/* Ensure our white scrollbar takes precedence */\nhtml,\nbody,\nhtml *,\nbody * {\n  scrollbar-width: thin !important;\n  scrollbar-color: rgba(255, 255, 255, 0.8) rgba(255, 255, 255, 0.05) !important;\n}\n/* Tour active - Fix modal spotlight positioning */\nbody.tour-active {\n  /* Prevent any transforms that could mess with joyride positioning */\n  transform: none !important;\n}\n\n/* Fix modal positioning during tours */\nbody.tour-active [id=\"tour-memo-modal\"] {\n  /* Reset scroll position to top when tour is active */\n  scroll-behavior: auto !important;\n}\n\n/* Prevent modal transforms during tour */\nbody.tour-active div[role=\"dialog\"],\nbody.tour-active div[id^=\"tour-\"] {\n  transform: none !important;\n  will-change: auto !important;\n}\n\n/* Ensure modal content is visible and positioned correctly */\nbody.tour-active div[id=\"tour-memo-modal\"] * {\n  transform: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
